import {
    GET_LIST_PEGAWAI_SLKS,
} from 'shared/constants/ActionTypes';

const INIT_STATE = {
    data: {
        results: []
    }
};

const slksReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_LIST_PEGAWAI_SLKS: {
            return {
                ...state,
                data: action.payload
            }
        }
        default:
            return state;
    }
};
export default slksReducer;
